import React from 'react'
import PropTypes from 'prop-types'
// import classnames from 'classnames'
// import shortid from 'shortid'
import '@fil-global/gds-webcomponents/fil-select/fil-select.component'
// import { selectMask } from '@fil-global/gds-components/scripts/select-dropdown/select-dropdown'
// import useComponentVisible from '../../hoc/useComponentVisible'
// import { Button } from 'gdpp-components/dist/cjs/components/atoms'

// import TextField from '../TextField'

import './style.scss'

// Reference: http://design-fidelity-gds-prod.fil.aldryn.io/components/dropdown/#develop
// const Select = ({ id, value, type, placeholder, options, disabled, required, filled, icon, status, extraClasses, layout, label, onChange }) => {
//   // const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false)
//   const [selectedValue, setSelectedValue] = useState(value)

//   const handleChange = (e) => {
//     onChange(e.target.value)
//     setSelectedValue(e.target.value)
//   }

//   // add or remove placeholder node
//   const handlePlaceholder = (operation) => {
//     const rootElement = document.querySelector(`#${id}`)
//     const inner = rootElement.querySelector('.fil-choices__inner')
//     if (!operation) {
//       const placeholderSpan = document.createElement('span')
//       placeholderSpan.setAttribute('id', 'placeholder')
//       placeholderSpan.textContent = placeholder
//       inner.appendChild(placeholderSpan)
//     } else {
//       const placeholderNode = inner.querySelector('#placeholder')
//       if (placeholderNode) {
//         placeholderNode.remove()
//       }
//     }
//   }

//   const handleRemovableEle = (counts, choice) => {
//     const rootElement = document.querySelector(`#${id}`)
//     const multipleDemo = rootElement.querySelector('.fil-choices__inner')
//     // check whether have removable node
//     const removableNode = multipleDemo.querySelector('#removedItem')

//     if (counts === 0 && removableNode) {
//       removableNode.remove()
//     }

//     if (!removableNode) {
//       const actionWrapper = document.createElement('div')
//       actionWrapper.setAttribute('id', 'removedItem')
//       actionWrapper.setAttribute('class', 'fil-choices__list fil-choices__list--multiple')
//       actionWrapper.innerHTML = `<div class="fil-choices__item fil-choices__item--removable"><span>${counts}</span> &nbsp;<button><fil-icon icon="close" size="8"></fil-icon></button></div><span>Options selected</span>`
//       const btn = actionWrapper.querySelector('button')

//       btn.addEventListener('click', (e) => {
//         choice.removeActiveItems()
//         e.stopPropagation()
//         handlePlaceholder()
//         actionWrapper.remove()
//       })
//       multipleDemo.appendChild(actionWrapper)
//     } else {
//       const selectedCountNode = removableNode.querySelector('span')
//       selectedCountNode.textContent = counts
//     }
//   }

//   useEffect(() => {
//     const rootElement = document.querySelector(`#${id}`)
//     const selectElem = rootElement.querySelector('select')
//     const option = {
//       placeholder
//     }

//     const choice = selectMask(selectElem, option, type === 'multiple')
//     const selectDOM = rootElement.querySelector('.fil-choices')

//     if (disabled) {
//       choice.disable()
//     } else {
//       selectDOM.addEventListener('click', () => {
//         choice.showDropdown()
//       })
//     }

//     if (type === 'multiple') {
//       handlePlaceholder()
//       selectDOM.addEventListener('choice', (event) => {
//         const currentChoiceValue = event.detail.choice.value
//         if (event.detail.choice.selected) {
//           setTimeout(() => {
//             choice.removeActiveItemsByValue(currentChoiceValue)
//             choice.triggerChange(currentChoiceValue)
//           }, 10)
//         }
//       })

//       selectDOM.addEventListener('change', () => {
//         const values = choice.getValue(true)
//         if (values.length > 0) {
//           handleRemovableEle(values.length, choice)
//           handlePlaceholder('remove')
//         } else {
//           handleRemovableEle(0, choice)
//           handlePlaceholder()
//         }

//         setSelectedValue(values)
//       })
//     } else {
//       //  this.hiddenSinglePlaceholder();
//       selectDOM.addEventListener('change', () => {
//         setSelectedValue(choice.getValue(true))
//       })
//     }
//   }, [])

//   return (
//     <TextField
//       {...{
//         elementId: id,
//         layout,
//         label
//       }}
//     >
//       <div className={classnames('fil-choice-wrapper', extraClasses)}>
//         <select
//           multiple={type === 'multiple'}
//           onChange={(e) => {
//             handleChange(e)
//           }}
//           value={selectedValue}
//           {...(disabled ? { disabled } : {})}
//           {...(required ? { required } : {})}
//           aria-required={required}
//         >
//           {type === 'single' && placeholder && <option defaultValue={value}>{placeholder}</option>}
//           {options.map((option, optionIndex) => (
//             <option key={`fil-select-${id}-option-${optionIndex}`} value={option.value}>
//               {type === 'single' && option.icon && icon && <fil-icon icon={option.icon} size="24" />}
//               {option.label}
//             </option>
//           ))}
//         </select>
//         {status && (
//           <fil-icon
//             icon={status === 'valid' ? 'custom-check-circle-1' : 'custom-alert-circle'}
//             size="20"
//             {...(filled ? { filled } : {})}
//             class="fil-text-field__icon"
//           />
//         )}
//       </div>
//     </TextField>
//   )
// }

// Select.propTypes = {
//   id: PropTypes.string.isRequired,
//   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   placeholder: PropTypes.string,
//   disabled: PropTypes.bool,
//   required: PropTypes.bool,
//   filled: PropTypes.bool,
//   options: PropTypes.array,
//   type: PropTypes.string,
//   icon: PropTypes.bool,
//   status: PropTypes.string,
//   extraClasses: PropTypes.string,
//   layout: PropTypes.string,
//   label: PropTypes.object,
//   onChange: PropTypes.func
// }

// Select.defaultProps = {
//   value: '',
//   placeholder: '',
//   disabled: false,
//   required: false,
//   filled: false,
//   options: [],
//   type: 'single',
//   icon: false,
//   status: '',
//   extraClasses: '',
//   layout: '1-col',
//   label: {},
//   onChange: () => {}
// }

// export default Select

const Select = ({ type, onChange, value, placeholder, extraProps, disabled, ...restProps }) => {
  const defaultExtraProps = { shouldSort: false }
  const allExtraProps = JSON.stringify({ ...defaultExtraProps, ...extraProps })

  // Open when GDS release a new version
  const formattedValue = Array.isArray(value) ? value.join(',') : value

  const ref = React.useRef()

  React.useLayoutEffect(() => {
    const handleChange = (customEvent) => onChange(customEvent.detail)
    const { current } = ref
    current.addEventListener('onchange', handleChange)
    return () => current.removeEventListener('onchange', handleChange)
  }, [ref])

  // Open when GDS release a new version
  return (
    <fil-select
      ref={ref}
      value={formattedValue}
      {...(disabled ? { disabled } : {})}
      type={type}
      extraProps={allExtraProps}
      placeholder={placeholder}
      {...restProps}
    />
  )
}

Select.propTypes = {
  type: PropTypes.string,
  onChange: PropTypes.func,
  extraProps: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  disabled: PropTypes.bool,
  placeholder: PropTypes.string
}

Select.defaultProps = {
  type: 'single',
  onChange: () => {},
  extraProps: {},
  value: '',
  placeholder: '',
  disabled: false
}

export default Select
